<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('baDoctorServiceCheck:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="用户id">
                <a-input v-model="queryParam.userId" allow-clear placeholder="请输入用户id"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="医院">
                <a-input v-model="queryParam.orgId" allow-clear placeholder="请输入医院"/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="科室">
                  <a-input v-model="queryParam.deptId" allow-clear placeholder="请输入科室"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="性别">
                  <a-input v-model="queryParam.sex" allow-clear placeholder="请输入性别"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="职称">
                  <a-input v-model="queryParam.protitle" allow-clear placeholder="请输入职称"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="电话">
                  <a-input v-model="queryParam.phone" allow-clear placeholder="请输入电话"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="身份证号">
                  <a-input v-model="queryParam.cardNo" allow-clear placeholder="请输入身份证号"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="医生简介">
                  <a-input v-model="queryParam.content" allow-clear placeholder="请输入医生简介"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="服务类型">
                  <a-input v-model="queryParam.expertIn" allow-clear placeholder="请输入服务类型"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="顺序号">
                  <a-input v-model="queryParam.orderNo" allow-clear placeholder="请输入顺序号"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="创建时间戳">
                  <a-date-picker style="width: 100%" placeholder="请选择创建时间戳" v-model="queryParam.ctstampDate" @change="onChangectstamp"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否删除（0否，1是）">
                  <a-input v-model="queryParam.delflag" allow-clear placeholder="请输入是否删除（0否，1是）"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="姓名">
                  <a-input v-model="queryParam.name" allow-clear placeholder="请输入姓名"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="角色">
                  <a-input v-model="queryParam.type" allow-clear placeholder="请输入角色"/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="8" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection"
      >
        <template class="table-operator" slot="operator" v-if="hasPerm('baDoctorServiceCheck:add')" >
          <a-button type="primary" v-if="hasPerm('baDoctorServiceCheck:add')" icon="plus" @click="$refs.addForm.add()">新增医生服务审核1</a-button>
          <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('baDoctorServiceCheck:delete')" @click="batchDelete"><a-icon type="delete"/>批量删除</a-button>
          <x-down
            v-if="hasPerm('baDoctorServiceCheck:export')"
            ref="batchExport"
            @batchExport="batchExport"
          />
        </template>
        <span slot="action" slot-scope="text, record">
          <a v-if="hasPerm('baDoctorServiceCheck:edit')" @click="$refs.editForm.edit(record)">编辑</a>
          <a-divider type="vertical" v-if="hasPerm('baDoctorServiceCheck:edit') & hasPerm('baDoctorServiceCheck:delete')"/>
          <a-popconfirm v-if="hasPerm('baDoctorServiceCheck:delete')" placement="topRight" title="确认删除？" @confirm="() => singleDelete(record)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </s-table>
      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import { baDoctorServiceCheckPage, baDoctorServiceCheckDelete, baDoctorServiceCheckExport } from '@/api/modular/interhospital/badoctorservicecheck/baDoctorServiceCheckManage'
  import addForm from './addForm.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '用户id',
            align: 'center',
            dataIndex: 'userId'
          },
          {
            title: '医院',
            align: 'center',
            dataIndex: 'orgId'
          },
          {
            title: '科室',
            align: 'center',
            dataIndex: 'deptId'
          },
          {
            title: '性别',
            align: 'center',
            dataIndex: 'sex'
          },
          {
            title: '职称',
            align: 'center',
            dataIndex: 'protitle'
          },
          {
            title: '电话',
            align: 'center',
            dataIndex: 'phone'
          },
          {
            title: '服务类型',
            align: 'center',
            dataIndex: 'expertIn'
          },
          {
            title: '创建时间戳',
            align: 'center',
            dataIndex: 'ctstamp'
          },
          {
            title: '姓名',
            align: 'center',
            dataIndex: 'name'
          },
          {
            title: '角色',
            align: 'center',
            dataIndex: 'type'
          }
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return baDoctorServiceCheckPage(Object.assign(parameter, this.switchingDate())).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    created () {
      if (this.hasPerm('baDoctorServiceCheck:edit') || this.hasPerm('baDoctorServiceCheck:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      moment,
      /**
       * 查询参数组装
       */
      switchingDate () {
        const queryParamctstamp = this.queryParam.ctstampDate
        if (queryParamctstamp != null) {
            this.queryParam.ctstamp = moment(queryParamctstamp).format('YYYY-MM-DD')
            if (queryParamctstamp.length < 1) {
                delete this.queryParam.ctstamp
            }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },
      /**
       * 单个删除
       */
      singleDelete (record) {
        const param = [{ 'id': record.id }]
        this.baDoctorServiceCheckDelete(param)
      },
      /**
       * 批量删除
       */
      batchDelete () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        this.baDoctorServiceCheckDelete(paramIds)
      },
      baDoctorServiceCheckDelete (record) {
        baDoctorServiceCheckDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        baDoctorServiceCheckExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      }
    }
  }
</script>
<style lang="less" scoped>
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
    
</style>
